import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast, Toaster } from "sonner";
import { API } from "../lib/api";
import { TabletAttendance } from "../components/tablet/TabletAttendance";
import { TabletSession } from "../components/tablet/TabletSession";

const pub = axios.create({ baseURL: API });

// Tablette coach — page publique (code kiosque) toujours ouverte au dojo : présences du cours + séance de groupe (curriculum).
export default function CoachTabletPage() {
  const [code, setCode] = useState(() => localStorage.getItem("coach_tablet_code") || "");
  const [input, setInput] = useState("");
  const [boot, setBoot] = useState(null);
  const [coach, setCoach] = useState(() => localStorage.getItem("coach_tablet_name") || "");
  const [tab, setTab] = useState("presences");
  const load = useCallback(async (c) => {
    try { const r = await pub.get("/public/coach-tablet/bootstrap", { params: { code: c } }); setBoot(r.data); localStorage.setItem("coach_tablet_code", c); setCode(c); }
    catch { toast.error("Code invalide"); localStorage.removeItem("coach_tablet_code"); setCode(""); setBoot(null); }
  }, []);
  useEffect(() => { if (code) load(code); }, [code, load]);
  useEffect(() => { if (!code) return; const t = setInterval(() => load(code), 10 * 60 * 1000); return () => clearInterval(t); }, [code, load]);
  useEffect(() => { localStorage.setItem("coach_tablet_name", coach); }, [coach]);
  if (!code || !boot) {
    return (
      <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-6" data-testid="tablet-login">
        <Toaster theme="dark" position="top-center" />
        <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/[0.03] p-8 space-y-4 text-center">
          <div className="text-[10px] tracking-[0.35em] text-[#C9A961]">INSTITUT IMPACT · TABLETTE COACH</div>
          <h1 className="text-2xl font-bold">Code du dojo</h1>
          <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load(input.trim())} placeholder="Code kiosque" className="w-full text-center text-2xl tracking-widest bg-zinc-900 border border-zinc-700 rounded-xl px-3 py-3" data-testid="tablet-code-input" />
          <button onClick={() => load(input.trim())} className="w-full py-3 rounded-xl bg-[#C9A961] text-zinc-950 font-bold text-lg" data-testid="tablet-code-submit">Ouvrir</button>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 p-4 sm:p-6" data-testid="tablet-page">
      <Toaster theme="dark" position="top-center" />
      <header className="flex flex-wrap items-center gap-3 mb-4">
        <div><div className="text-[10px] tracking-[0.35em] text-[#C9A961]">TABLETTE COACH · {boot.jour} {boot.today}</div><h1 className="text-2xl font-bold">Institut Impact</h1></div>
        <select value={coach} onChange={(e) => setCoach(e.target.value)} className="ml-auto bg-zinc-900 border border-zinc-700 rounded-xl px-3 py-2 text-base" data-testid="tablet-coach-select">
          <option value="">— Qui enseigne ? —</option>{boot.coaches.map((c) => <option key={c}>{c}</option>)}</select>
        <div className="flex rounded-xl overflow-hidden border border-zinc-700">
          {[["presences", "✅ Présences"], ["seance", "🎯 Séance de groupe"]].map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`px-4 py-2 text-base font-semibold ${tab === k ? "bg-[#C9A961] text-zinc-950" : "bg-zinc-900 text-zinc-300"}`} data-testid={`tablet-tab-${k}`}>{l}</button>)}
        </div>
        <button onClick={() => { localStorage.removeItem("coach_tablet_code"); setCode(""); setBoot(null); }} className="text-xs text-zinc-500" data-testid="tablet-lock">🔒 Verrouiller</button>
      </header>
      {!coach && <p className="mb-3 text-amber-300 text-sm" data-testid="tablet-no-coach">Choisis ton nom en haut à droite avant de valider des présences.</p>}
      {tab === "presences" ? <TabletAttendance pub={pub} code={code} boot={boot} coach={coach} /> : <TabletSession pub={pub} code={code} boot={boot} coach={coach} onChange={() => load(code)} />}
    </div>
  );
}
